// These word need to be checked with s/e/es suffixes.
var adjectivesVerbs = [
	// The following words are participles of verbs that cannot be passives.
	"allé",
	"arrivé",
	"décédé",
	"demeuré",
	"entré",
	"été",
	"né",
	"resté",
	"retombé",
	"tombé",
	// The following words are non-participles ending in é.
	"achalandé",
	"aéroporté",
	"affilé",
	"affixé",
	"âgé",
	"aîné",
	"aisé",
	"aligoté",
	"alizé",
	"alliacé",
	"alluré",
	"alphabétisé",
	"alvéolé",
	"aminé",
	"ammoniaqué",
	"ampoulé",
	"archi-prouvé",
	"archi-usé",
	"asexué",
	"autoguidé",
	"autopropulsé",
	"aviné",
	"baleiné",
	"barbelé",
	"baryté",
	"bien-aimé",
	"bisexué",
	"bouqueté",
	"brioché",
	"burkinabé",
	"cagoulé",
	"calamistré",
	"cannelé",
	"carabiné",
	"carboné",
	"caréné",
	"carié",
	"carminé",
	"carné",
	"carpé",
	"censé",
	"cérusé",
	"charançonné",
	"chenillé",
	"chocolaté",
	"chtarbé",
	"citronné",
	"cofondé",
	"contrecollé",
	"côtelé",
	"courbaturé",
	"crawlé",
	"crossé",
	"crustacé",
	"cutané",
	"damasquiné",
	"damassé",
	"débellé",
	"décavé",
	"déguenillé",
	"demi-paralysé",
	"denté",
	"dépenaillé",
	"désenchanté",
	"désodé",
	"diapré",
	"ébranché",
	"écervelé",
	"effréné",
	"effronté",
	"éhonté",
	"embourgeoisé",
	"embroussaillé",
	"embruiné",
	"émerillonné",
	"encalminé",
	"encaustiqué",
	"encorné",
	"endiablé",
	"endiamanté",
	"enfoiré",
	"enfouraillé",
	"ensellé",
	"entrelardé",
	"éploré",
	"ergoté",
	"erroné",
	"étagé",
	"éthéré",
	"éversé",
	"éwé",
	"ex-associé",
	"exorbité",
	"expansé",
	"famé",
	"férié",
	"fibré",
	"filoguidé",
	"flammé",
	"fleurdelisé",
	"fliqué",
	"flûté",
	"forcené",
	"fortuné",
	"foulbé",
	"frelaté",
	"friqué",
	"futé",
	"gazonné",
	"gracieusé",
	"gradé",
	"granulé",
	"herminé",
	"hiérarchisé",
	"huppé",
	"hydrogéné",
	"igné",
	"illettré",
	"illimité",
	"imbriqué",
	"immaculé",
	"immérité",
	"immodéré",
	"immunodéprimé",
	"impayé",
	"impensé",
	"impollué",
	"imprononcé",
	"inaccoutumé",
	"inachevé",
	"inactivé",
	"inadapté",
	"inaltéré",
	"inanimé",
	"inapproprié",
	"inarticulé",
	"inavoué",
	"inchangé",
	"inconditionné",
	"inconsidéré",
	"inconsolé",
	"incontesté",
	"incontrôlé",
	"incréé",
	"indéfriché",
	"indéterminé",
	"indifférencié",
	"indiscipliné",
	"indiscuté",
	"indivisé",
	"indompté",
	"inébranlé",
	"inemployé",
	"inentamé",
	"inespéré",
	"inexpérimenté",
	"inexpliqué",
	"inexploité",
	"inexploré",
	"inexprimé",
	"infondé",
	"informulé",
	"infortuné",
	"inhabité",
	"inimité",
	"injustifié",
	"inné",
	"innommé",
	"inoccupé",
	"inopiné",
	"inorganisé",
	"inoublié",
	"insensé",
	"insoupçonné",
	"instantané",
	"insubordonné",
	"insurpassé",
	"intentionné",
	"interallié",
	"intouché",
	"inusité",
	"inutilisé",
	"invertébré",
	"inviolé",
	"iodé",
	"irraisonné",
	"irréalisé",
	"lacté",
	"lamé",
	"lamifié",
	"larvé",
	"laryngé",
	"léopardé",
	"lettré",
	"lié",
	"lifté",
	"losangé",
	"luné",
	"lunetté",
	"madré",
	"maillé",
	"malaisé",
	"malavisé",
	"maléficié",
	"malfamé",
	"malformé",
	"malintentionné",
	"mendé",
	"ménopausé",
	"mentholé",
	"mi-accablé",
	"mi-allongé",
	"mi-café",
	"mi-consterné",
	"mi-enterré",
	"mi-étonné",
	"mi-pincé",
	"mi-terrorisé",
	"miellé",
	"millimétré",
	"miraculé",
	"momentané",
	"monoclé",
	"monté",
	"mordoré",
	"mort-né",
	"névrosé",
	"nitré",
	"non-initié",
	"nouveau-né",
	"olé-olé",
	"ongulé",
	"paillé",
	"palé",
	"papilionacé",
	"paqueté",
	"paraffiné",
	"passé",
	"pasteurisé",
	"patenté",
	"paysagé",
	"pédonculé",
	"pestiféré",
	"platiné",
	"pocheté",
	"polychromé",
	"poplité",
	"potelé",
	"pourpré",
	"praliné",
	"précité",
	"prédigéré",
	"préencollé",
	"préfabriqué",
	"prématuré",
	"premier-né",
	"préprogrammé",
	"prostré",
	"protéiné",
	"pyramidé",
	"quadrilobé",
	"racé",
	"re-café",
	"re-rêvé",
	"re-vérifié",
	"rebarré",
	"redécoré",
	"relargué",
	"remonté",
	"rentré",
	"résiné",
	"ressuscité",
	"réticulé",
	"retourné",
	"revérifié",
	"revivifié",
	"rose-thé",
	"safrané",
	"satiné",
	"saumoné",
	"sébacé",
	"sensé",
	"sexué",
	"sigillé",
	"silicosé",
	"simultané",
	"sinistré",
	"soufré",
	"sous-cutané",
	"sous-développé",
	"sous-qualifié",
	"soussigné",
	"spiralé",
	"spontané",
	"stratifié",
	"sulfaté",
	"sulfuré",
	"sulfurisé",
	"suractivé",
	"suranné",
	"surbooké",
	"surbrodé",
	"surdéveloppé",
	"surdimensionné",
	"surdoué",
	"surentraîné",
	"suroxygéné",
	"surpeuplé",
	"surqualifié",
	"susmentionné",
	"susnommé",
	"systématisé",
	"tarabiscoté",
	"taupé",
	"thrombosé",
	"tiercé",
	"timoré",
	"tiqueté",
	"transcutané",
	"triphasé",
	"usagé",
	"usité",
	"vallonné",
	"vanillé",
	"vascularisé",
	"veinulé",
	"venté",
	"vergé",
	"vert-de-grisé",
	"vertébré",
	"vitaminé",
	"vulcanisé",
	"zélé",
];

/*
The following words are nouns ending in -é or -ée and starting with a vowel.
These words need to be checked with -s suffixes and l' and d' prefixes.
 */
var nounsStartingWithVowel = [
	"à-côté",
	"abbé",
	"absurdité",
	"accessibilité",
	"acerbité",
	"acidité",
	"acmé",
	"acné",
	"âcreté",
	"activité",
	"actualité",
	"acuité",
	"adaptabilité",
	"adiposité",
	"admissibilité",
	"adversité",
	"affabilité",
	"affectivité",
	"affidé",
	"affinité",
	"agilité",
	"agressivité",
	"alacrité",
	"alcalinité",
	"altérité",
	"amabilité",
	"ambiguïté",
	"amé",
	"aménité",
	"américanité",
	"amirauté",
	"amitié",
	"amoralité",
	"ancestralité",
	"ancienneté",
	"anfractuosité",
	"angulosité",
	"animalité",
	"animosité",
	"anormalité",
	"anti-acné",
	"anti-cité",
	"anti-criminalité",
	"anti-gravité",
	"anti-intimité",
	"anti-société",
	"antigravité",
	"antiquité",
	"anxiété",
	"aparté",
	"applicabilité",
	"âpreté",
	"archevêché",
	"aridité",
	"artificialité",
	"asexualité",
	"asociabilité",
	"aspérité",
	"assiduité",
	"astarté",
	"atrocité",
	"austérité",
	"authenticité",
	"autodafé",
	"autorité",
	"avé",
	"aveugle-né",
	"avidité",
	"ébriété",
	"effectivité",
	"efficacité",
	"égalité",
	"élasticité",
	"électricité",
	"élément-clé",
	"élémentarité",
	"éligibilité",
	"émotivité",
	"empaffé",
	"énormité",
	"entièreté",
	"entité",
	"enviandé",
	"épitomé",
	"équanimité",
	"équité",
	"étanchéité",
	"éternité",
	"ethnicité",
	"étrangéité",
	"étrangeté",
	"euromarché",
	"évêché",
	"éventualité",
	"ex-abbé",
	"ex-fiancé",
	"excentricité",
	"exclusivité",
	"exemplarité",
	"exhaustivité",
	"exiguïté",
	"extériorité",
	"externalité",
	"exterritorialité",
	"extrémité",
	"idée-clé",
	"identité",
	"illégalité",
	"illégitimité",
	"imbécillité",
	"immatérialité",
	"immaturité",
	"immédiateté",
	"immensité",
	"immobilité",
	"immoralité",
	"immortalité",
	"immuabilité",
	"immunité",
	"immutabilité",
	"impalpabilité",
	"impartialité",
	"impassibilité",
	"impeccabilité",
	"impécuniosité",
	"impénétrabilité",
	"imperméabilité",
	"impersonnalité",
	"impétuosité",
	"impiété",
	"implacabilité",
	"impopularité",
	"impossibilité",
	"impraticabilité",
	"imprévisibilité",
	"improbabilité",
	"impudicité",
	"impulsivité",
	"impunité",
	"impureté",
	"inaccessibilité",
	"inactivité",
	"inanité",
	"inauthenticité",
	"incapacité",
	"incommodité",
	"incommunicabilité",
	"incompatibilité",
	"incongruité",
	"incorruptibilité",
	"incrédibilité",
	"incrédulité",
	"incuriosité",
	"indemnité",
	"indestructibilité",
	"indignité",
	"indisponibilité",
	"individualité",
	"indivisibilité",
	"indocilité",
	"industrie-clé",
	"inefficacité",
	"inégalité",
	"inéligibilité",
	"inéluctabilité",
	"inévitabilité",
	"inexorabilité",
	"infaillibilité",
	"infécondité",
	"infériorité",
	"infertilité",
	"infidélité",
	"infinité",
	"infirmité",
	"inflammabilité",
	"inflexibilité",
	"ingéniosité",
	"ingénuité",
	"inhospitalité",
	"inhumanité",
	"inimitié",
	"iniquité",
	"innocuité",
	"inopportunité",
	"insalubrité",
	"insanité",
	"insécurité",
	"insensibilité",
	"inséparabilité",
	"insincérité",
	"insipidité",
	"insonorité",
	"instabilité",
	"instantanéité",
	"insularité",
	"intangibilité",
	"intégralité",
	"intégrité",
	"intelligibilité",
	"intemporalité",
	"intensité",
	"intentionnalité",
	"interactivité",
	"intériorité",
	"intimité",
	"intrépidité",
	"inusabilité",
	"inutilité",
	"invalidité",
	"inventivité",
	"invincibilité",
	"inviolabilité",
	"invisibilité",
	"invulnérabilité",
	"irrationalité",
	"irréalité",
	"irrecevabilité",
	"irrégularité",
	"irréligiosité",
	"irresponsabilité",
	"irréversibilité",
	"irrévocabilité",
	"irritabilité",
	"obésité",
	"objectivité",
	"obliquité",
	"obscénité",
	"obscurité",
	"obséquiosité",
	"officialité",
	"oiseau-clé",
	"oisiveté",
	"okoumé",
	"onctuosité",
	"opacité",
	"opiniâtreté",
	"opportunité",
	"oralité",
	"originalité",
	"ubiquité",
	"ukulélé",
	"unanimité",
	"unicité",
	"uniformité",
	"unilatéralité",
	"unité",
	"universalité",
	"université",
	"urbanité",
	"utilité",
	"yé-yé",
	"yéyé",
	"achillée",
	"almée",
	"aménorrhée",
	"année",
	"anti-nausée",
	"apnée",
	"apogée",
	"araignée",
	"arrière-pensée",
	"assiettée",
	"athénée",
	"auloffée",
	"aveugle-née",
	"avrillée",
	"azalée",
	"échauffourée",
	"écuellée",
	"élysée",
	"embardée",
	"empyrée",
	"épée",
	"épopée",
	"étuvée",
	"ex-allée",
	"ex-dulcinée",
	"ex-fiancée",
	"ex-lycée",
	"idée",
	"ipomée",
	"odyssée",
	"onomatopée",
	"orchidée",
	"orée",
	"orphée",
	"urée",
];

/*
The following words are nouns ending in -é or -ée and starting with a consonant.
These words need to be checked with -s suffixes.
*/
var nounsStartingWithConsonant = [
	"banalité",
	"bas-côté",
	"beaupré",
	"beauté",
	"bébé",
	"bédé",
	"bénédicité",
	"bénignité",
	"bestialité",
	"bien-fondé",
	"biodiversité",
	"bipolarité",
	"bisexualité",
	"blé",
	"bonté",
	"bout-rimé",
	"bovidé",
	"brièveté",
	"brutalité",
	"caducité",
	"café",
	"callosité",
	"camélidé",
	"canapé",
	"capacité",
	"capillarité",
	"captivité",
	"carte-clé",
	"caté",
	"catholicité",
	"causalité",
	"causticité",
	"cavité",
	"cécité",
	"célébrité",
	"célérité",
	"cérébralité",
	"cétacé",
	"charité",
	"chassé-croisé",
	"chasteté",
	"cherté",
	"chétivité",
	"chimpanzé",
	"chrétienté",
	"ciné",
	"cinéma-vérité",
	"circularité",
	"citoyenneté",
	"civilité",
	"clandé",
	"clandestinité",
	"clarté",
	"clé",
	"clergé",
	"co-propriété",
	"coaccusé",
	"cochonceté",
	"code-clé",
	"collectivité",
	"collégialité",
	"combativité",
	"comestibilité",
	"comité",
	"commodité",
	"communauté",
	"communicabilité",
	"compacité",
	"comparabilité",
	"compatibilité",
	"compétitivité",
	"complémentarité",
	"complexité",
	"complicité",
	"comptabilité",
	"comté",
	"concavité",
	"condé",
	"conductibilité",
	"conductivité",
	"confidentialité",
	"conformité",
	"confraternité",
	"congé",
	"conjugalité",
	"connectivité",
	"consanguinité",
	"constitutionnalité",
	"contiguïté",
	"continuité",
	"contrariété",
	"contre-gré",
	"contre-plaqué",
	"contre-vérité",
	"contreplaqué",
	"contrevérité",
	"convexité",
	"convivialité",
	"coopé",
	"copropriété",
	"cordialité",
	"coré",
	"coriacité",
	"corporalité",
	"côté",
	"créativité",
	"crédibilité",
	"crédulité",
	"crétacé",
	"criminalité",
	"cruauté",
	"crudité",
	"culpabilité",
	"cupidité",
	"curiosité",
	"cybercafé",
	"cyprinidé",
	"dangerosité",
	"daphné",
	"dé",
	"débotté",
	"décimalité",
	"décision-clé",
	"déclivité",
	"déductibilité",
	"défectuosité",
	"degré",
	"déité",
	"déloyauté",
	"demi-clarté",
	"demi-degré",
	"demi-liberté",
	"demi-obscurité",
	"demi-vérité",
	"dénatalité",
	"densité",
	"député",
	"dératé",
	"dernier-né",
	"désirabilité",
	"dextérité",
	"difficulté",
	"difformité",
	"dignité",
	"discontinuité",
	"disparité",
	"disponibilité",
	"diversité",
	"divinité",
	"docilité",
	"domesticité",
	"doyenné",
	"dualité",
	"duché",
	"duplicité",
	"durabilité",
	"dureté",
	"faculté",
	"faillibilité",
	"faisabilité",
	"familiarité",
	"fatalité",
	"fatuité",
	"fausseté",
	"fébrilité",
	"fécondité",
	"félidé",
	"félinité",
	"féminité",
	"féodalité",
	"fermeté",
	"férocité",
	"ferté",
	"fertilité",
	"festivité",
	"fétidité",
	"fiabilité",
	"fibrillé",
	"fidélité",
	"fierté",
	"finalité",
	"fiscalité",
	"fixité",
	"flaccidité",
	"flatuosité",
	"flexibilité",
	"flexuosité",
	"flottabilité",
	"fluidité",
	"fonctionnalité",
	"formalité",
	"fossé",
	"fragilité",
	"francité",
	"fraternité",
	"friabilité",
	"frigidité",
	"frilosité",
	"fringillidé",
	"frivolité",
	"frugalité",
	"fugacité",
	"furtivité",
	"futilité",
	"gaieté",
	"gaîté",
	"gallinacé",
	"gémellité",
	"généralité",
	"générosité",
	"génialité",
	"génitalité",
	"germanité",
	"gibbosité",
	"globalité",
	"godemiché",
	"gracieuseté",
	"gracilité",
	"grand-duché",
	"granité",
	"gratuité",
	"gravidité",
	"gré",
	"grossièreté",
	"habileté",
	"habitabilité",
	"haute-fidélité",
	"henné",
	"hérédité",
	"hétérogénéité",
	"hétérosexualité",
	"hilarité",
	"histocompatibilité",
	"historicité",
	"homme-clé",
	"homogénéité",
	"homosexualité",
	"honnêteté",
	"honorabilité",
	"horizontalité",
	"hospitalité",
	"hostilité",
	"humanité",
	"humidité",
	"humilité",
	"hyperacidité",
	"hyperactivité",
	"hypercoagulabilité",
	"hyperémotivité",
	"hypermarché",
	"hyperréactivité",
	"hypersensibilité",
	"jovialité",
	"joyeuseté",
	"jubé",
	"judaïcité",
	"judaïté",
	"judéité",
	"juvénilité",
	"karaoké",
	"karaté",
	"karité",
	"kiné",
	"koré",
	"lâcheté",
	"laïcité",
	"lamedé",
	"lascivité",
	"latéralité",
	"latinité",
	"laubé",
	"laxité",
	"lé",
	"légalité",
	"légèreté",
	"légitimité",
	"lèse-majesté",
	"létalité",
	"lettre-clé",
	"libéralité",
	"liberté",
	"licéité",
	"limpidité",
	"liquidité",
	"lisibilité",
	"littéralité",
	"lividité",
	"localité",
	"longanimité",
	"longévité",
	"loquacité",
	"loyauté",
	"lubricité",
	"lucidité",
	"luminosité",
	"macramé",
	"magnanimité",
	"majesté",
	"majorité",
	"mal-aimé",
	"mal-baisé",
	"malhonnêteté",
	"malignité",
	"malinké",
	"malléabilité",
	"malpropreté",
	"maniabilité",
	"manoeuvrabilité",
	"marginalité",
	"masculinité",
	"maskinongé",
	"massivité",
	"matérialité",
	"maternité",
	"matité",
	"maturité",
	"mauvaiseté",
	"méchanceté",
	"médiocrité",
	"médiumnité",
	"mémé",
	"mémorabilité",
	"mendicité",
	"mensualité",
	"mentalité",
	"merveillosité",
	"méticulosité",
	"mi-capacité",
	"mi-été",
	"mi-meublé",
	"mi-porté",
	"mi-réalité",
	"mi-résigné",
	"miché",
	"microgravité",
	"minorité",
	"mitoyenneté",
	"mixité",
	"mobilité",
	"mocheté",
	"modalité",
	"modernité",
	"modicité",
	"moment-clé",
	"mondanité",
	"monstruosité",
	"mont-de-piété",
	"monumentalité",
	"mooré",
	"moralité",
	"morbidité",
	"morosité",
	"mortalité",
	"mot-clé",
	"motilité",
	"motricité",
	"mousmé",
	"mucosité",
	"multiplicité",
	"multipropriété",
	"municipalité",
	"musicalité",
	"mutabilité",
	"mutité",
	"mutualité",
	"naïveté",
	"narghilé",
	"narguilé",
	"natalité",
	"nationalité",
	"nativité",
	"navigabilité",
	"nébulosité",
	"négativité",
	"néné",
	"nervosité",
	"nescafé",
	"netteté",
	"neutralité",
	"névé",
	"niakoué",
	"niébé",
	"nocivité",
	"non-conformité",
	"non-culpabilité",
	"nordicité",
	"normalité",
	"notabilité",
	"notoriété",
	"nouveauté",
	"nouvelleté",
	"nubilité",
	"nudité",
	"nue-propriété",
	"nullité",
	"nuptialité",
	"papauté",
	"papé",
	"parenté",
	"parité",
	"partialité",
	"particularité",
	"passiveté",
	"passivité",
	"pâté",
	"paternité",
	"pause-café",
	"pauses-café",
	"pauvreté",
	"pédé",
	"pédégé",
	"pénalité",
	"pépé",
	"pérennité",
	"perfectibilité",
	"périodicité",
	"perméabilité",
	"permissivité",
	"péroné",
	"perpétuité",
	"perplexité",
	"perré",
	"personnage-clé",
	"personnalité",
	"perspicacité",
	"perversité",
	"pèse-bébé",
	"petit-salé",
	"photosensibilité",
	"phrase-clé",
	"pilosité",
	"pisé",
	"pitié",
	"placidité",
	"plasticité",
	"plausibilité",
	"pluralité",
	"pluviosité",
	"point-clé",
	"poiré",
	"poire-vérité",
	"polarité",
	"polycopié",
	"polytonalité",
	"ponctualité",
	"pongé",
	"popularité",
	"porosité",
	"portabilité",
	"porte-bébé",
	"porte-clé",
	"position-clé",
	"positivité",
	"possessivité",
	"possibilité",
	"poste-clé",
	"postérité",
	"potentialité",
	"pousse-café",
	"pré",
	"pré-salé",
	"précarité",
	"préciosité",
	"précocité",
	"prématurité",
	"prévisibilité",
	"prévôté",
	"prieuré",
	"primauté",
	"principauté",
	"priorité",
	"privauté",
	"probabilité",
	"probité",
	"prodigalité",
	"productivité",
	"profitabilité",
	"prolixité",
	"promiscuité",
	"proportionnalité",
	"propreté",
	"propriété",
	"prospérité",
	"proximité",
	"psyché",
	"puberté",
	"publicité",
	"pudicité",
	"puérilité",
	"pugnacité",
	"puîné",
	"pureté",
	"pusillanimité",
	"qualité",
	"quantité",
	"quarté",
	"quasi-impossibilité",
	"quasi-impunité",
	"quasi-nudité",
	"quasi-totalité",
	"quasi-unanimité",
	"question-clé",
	"quinté",
	"quotidienneté",
	"quotité",
	"radioactivité",
	"raisiné",
	"rapacité",
	"raphé",
	"rapidité",
	"rareté",
	"rationalité",
	"raucité",
	"ré",
	"réactivité",
	"réalité",
	"récépissé",
	"réceptivité",
	"recevabilité",
	"réciprocité",
	"récré",
	"régularité",
	"relativité",
	"religiosité",
	"rentabilité",
	"reportage-vérité",
	"respectabilité",
	"responsabilité",
	"réversibilité",
	"rigidité",
	"risibilité",
	"rivalité",
	"romanité",
	"rotondité",
	"roulé-boulé",
	"royauté",
	"rugosité",
	"rusticité",
	"sagacité",
	"saint-honoré",
	"sainteté",
	"saké",
	"salacité",
	"saleté",
	"salinité",
	"salmonidé",
	"salubrité",
	"santé",
	"sapidité",
	"satiété",
	"sauveté",
	"scène-clé",
	"scientificité",
	"scissiparité",
	"scolarité",
	"scrupulosité",
	"sécurité",
	"sédentarité",
	"sélectivité",
	"semi-liberté",
	"séné",
	"sénevé",
	"sénilité",
	"sensibilité",
	"sensorialité",
	"sensualité",
	"sentimentalité",
	"septicité",
	"sérénité",
	"sergé",
	"séropositivité",
	"sérosité",
	"serviabilité",
	"servilité",
	"sévérité",
	"sexualité",
	"similarité",
	"simplicité",
	"simultanéité",
	"sincérité",
	"singularité",
	"sinuosité",
	"sobriété",
	"sociabilité",
	"société",
	"solennité",
	"solidarité",
	"solidité",
	"solubilité",
	"soluté",
	"solvabilité",
	"sommité",
	"somptuosité",
	"sonorité",
	"sordidité",
	"sororité",
	"soudaineté",
	"sous-comité",
	"sous-humanité",
	"souveraineté",
	"spasticité",
	"spécialité",
	"spécificité",
	"sphéricité",
	"spiritualité",
	"spontanéité",
	"sportivité",
	"spumosité",
	"stabilité",
	"sténopé",
	"stérilité",
	"stupidité",
	"suavité",
	"subjectivité",
	"sublimité",
	"subtilité",
	"succédané",
	"suggestibilité",
	"suggestivité",
	"superficialité",
	"superfluité",
	"supériorité",
	"supermarché",
	"supraconductivité",
	"suractivité",
	"surcapacité",
	"surdité",
	"sûreté",
	"surgé",
	"surhumanité",
	"surintensité",
	"surréalité",
	"susceptibilité",
	"suzeraineté",
	"synthé",
	"taboulé",
	"taciturnité",
	"tamouré",
	"tangibilité",
	"tarpé",
	"technicité",
	"télé",
	"témérité",
	"témoin-clé",
	"temporalité",
	"ténacité",
	"tendreté",
	"ténébrionidé",
	"ténuité",
	"territorialité",
	"tévé",
	"thé",
	"théâtralité",
	"tiaré",
	"timidité",
	"tollé",
	"tonalité",
	"tonicité",
	"totalité",
	"toxicité",
	"traçabilité",
	"tranquillité",
	"translucidité",
	"transsexualité",
	"trinité",
	"trivialité",
	"tsé-tsé",
	"tubérosité",
	"turbé",
	"vacuité",
	"vahiné",
	"validité",
	"vanité",
	"variabilité",
	"variété",
	"vassalité",
	"vastité",
	"velléité",
	"vélocité",
	"vénalité",
	"vénusté",
	"véracité",
	"verbosité",
	"vérité",
	"versatilité",
	"verticalité",
	"vétusté",
	"viabilité",
	"vicinalité",
	"vicomté",
	"viduité",
	"virginité",
	"virilité",
	"virtualité",
	"virtuosité",
	"viscosité",
	"visibilité",
	"vitalité",
	"vivacité",
	"volatilité",
	"volonté",
	"volubilité",
	"volupté",
	"voracité",
	"vulgarité",
	"vulnérabilité",
	"batée",
	"becquée",
	"billevesée",
	"bolée",
	"bondrée",
	"borée",
	"bouée",
	"bougainvillée",
	"brouettée",
	"buée",
	"caducée",
	"canne-épée",
	"casserolée",
	"cavée",
	"centaurée",
	"cépée",
	"céphalée",
	"charretée",
	"chaudronnée",
	"chicorée",
	"chorée",
	"cochlée",
	"cochonnée",
	"colée",
	"contre-allée",
	"contre-plongée",
	"corvée",
	"coryphée",
	"cucurbitacée",
	"cuillerée",
	"culée",
	"cylindrée",
	"demi-journée",
	"demi-volée",
	"denrée",
	"dernière-née",
	"diarrhée",
	"diatomée",
	"dionée",
	"dragée",
	"dulcinée",
	"dysménorrhée",
	"dyspnée",
	"fée",
	"feuillée",
	"flopée",
	"fournée",
	"fricassée",
	"friselée",
	"galathée",
	"galée",
	"giboulée",
	"giroflée",
	"gonorrhée",
	"goulée",
	"graminée",
	"guinée",
	"gynécée",
	"haquenée",
	"hottée",
	"hyménée",
	"hyperborée",
	"hypogée",
	"journée",
	"lance-fusée",
	"litée",
	"logorrhée",
	"lycée",
	"macchabée",
	"mainlevée",
	"maisonnée",
	"mal-aimée",
	"mal-baisée",
	"maréchaussée",
	"marée",
	"mausolée",
	"mélopée",
	"mi-effrontée",
	"mi-journée",
	"miellée",
	"mijaurée",
	"mosquée",
	"moteur-fusée",
	"muflée",
	"nausée",
	"nuée",
	"nuitée",
	"panacée",
	"pâtée",
	"peignée",
	"pelletée",
	"pépée",
	"périgée",
	"périnée",
	"pharmacopée",
	"pipée",
	"platée",
	"pochetée",
	"pochetée",
	"poignée",
	"poirée",
	"poisson-épée",
	"porte-épée",
	"potée",
	"poupée",
	"première-née",
	"prérentrée",
	"presse-purée",
	"prytanée",
	"purée",
	"quasi-fiancée",
	"ramée",
	"raz-de-marée",
	"resucée",
	"rétrofusée",
	"rez-de-chaussée",
	"risée",
	"ruchée",
	"scarabée",
	"séborrhée",
	"sigisbée",
	"simagrée",
	"singe-araignée",
	"soirée",
	"solanacée",
	"tablée",
	"tinée",
	"trachée",
	"trâlée",
	"transfusée",
	"travée",
	"trépanée",
	"trochée",
	"trophée",
	"vallée",
	"ventrée",
	"vesprée",
];

// These words do not need to be checked with any suffixes.
var others = [
	"bé",
	"cré",
	"crédié",
	"é",
	"loucedé",
	"eussé",
	"hé",
	"malgré",
	"moitié-moitié",
	"ohé",
	"olé",
	"ollé",
	"sacrédié",
	"d'emblée",
	"quasi-instantanée",
];


/**
 * Returns a list of participle exceptions for French.
 *
 * @returns {Object} French participle exceptions.
 */
export default function() {
	return {
		adjectivesVerbs: adjectivesVerbs,
		nounsStartingWithVowel: nounsStartingWithVowel,
		nounsStartingWithConsonant: nounsStartingWithConsonant,
		others: others,
	};
}
